import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Svg from 'rp-react-svg-icon';

export default function ShortlistButton({ className, children, highlighted, disabled, onClick }) {
    return (
        <button
            className={classnames('shortlistButton', className)}
            disabled={disabled}
            onClick={onClick}
        >
        {
            !highlighted ?
                <Svg
                    className={classnames({
                        shortlistButton__icon: true,
                    })}
                    size="Medium"
                    iconName="starHollow"
                /> :
                <Svg
                    className={classnames({
                        shortlistButton__icon: true,
                        shortlistButton__icon_highlighted: highlighted,
                    })}
                    size="Medium"
                    iconName="starFilled"
                />
        }
            {children}
        </button>
    );
}

ShortlistButton.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    highlighted: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/js/components/ShortlistButton/ShortlistButton.js